import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import RequireAuth from './components/auth/RequireAuth';

// Route-level code splitting: each page loads as its own chunk, keeping the
// initial bundle small (the profile dashboard in particular is heavy).
const Home = lazy(() => import('./Views/Home'));
const About = lazy(() => import('./Views/About'));
const ContactUs = lazy(() => import('./Views/ContactUs'));
const FAQ = lazy(() => import('./Views/FAQ'));
const Packages = lazy(() => import('./Views/Packages'));
const Services = lazy(() => import('./Views/Services'));
const Appartments = lazy(() => import('./Views/Appartments'));
const LoginPage = lazy(() => import('./Views/SignIn'));
const SignupPage = lazy(() => import('./Views/SignUp'));
const ForgotPassword = lazy(() => import('./Views/ForgotPassword'));
const ResetPassword = lazy(() => import('./Views/ResetPassword'));
const VerifyEmail = lazy(() => import('./Views/VerifyEmail'));
const PaymentReturn = lazy(() => import('./Views/PaymentReturn'));
const PayRequest = lazy(() => import('./Views/PayRequest'));
const Profile = lazy(() => import('./Views/Profile'));
const Announcements = lazy(() => import('./Views/Announcements'));
const Terms = lazy(() => import('./Views/Terms'));
const Privacy = lazy(() => import('./Views/Privacy'));
const Cgv = lazy(() => import('./Views/Cgv'));
const NotFound = lazy(() => import('./Views/NotFound'));

function RouteFallback() {
  return (
    <div className="flex h-dvh w-full items-center justify-center" role="status" aria-label="Loading">
      <span className="h-10 w-10 animate-spin rounded-full border-4 border-light-orange border-t-transparent" />
    </div>
  );
}

function App() {
  return (
    <div className="App w-full min-h-screen">
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/">
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="services" element={<Services />} />
            <Route path="packages" element={<Packages />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="contact" element={<ContactUs />} />
            <Route path="accommodations" element={<Appartments />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="signup" element={<SignupPage />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="verify-email" element={<VerifyEmail />} />
            <Route path="terms" element={<Terms />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="cgv" element={<Cgv />} />
            {/* Public: shows the charge before sign-in; paying is auth-gated
                on the page itself (with resume back here after login). */}
            <Route path="pay/:token" element={<PayRequest />} />
            <Route
              path="payment/return"
              element={
                <RequireAuth>
                  <PaymentReturn />
                </RequireAuth>
              }
            />
            <Route path="announcements" element={<Announcements />} />
            <Route
              path="profile"
              element={
                <RequireAuth>
                  <Profile />
                </RequireAuth>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
